import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { MenuItems } from "../types";
import { getRagObjectsReducerBuilder } from "./reducers";
import type { SidebarItemsState } from "./types";

const initialState: SidebarItemsState = {
  folderItems: [],
  ragObjects: [],
  isLoading: false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleAccordion: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      if (state.folderItems.includes(id)) {
        state.folderItems = state.folderItems.filter(
          (accordionId) => accordionId !== id
        );
      } else {
        state.folderItems.push(id);
      }
    },
    closeAccordion: (state, action: PayloadAction<string>) => {
      state.folderItems = state.folderItems.filter(
        (id) => id !== action.payload
      );
    },
    openAccordion: (state, action: PayloadAction<string>) => {
      if (!state.folderItems.includes(action.payload)) {
        state.folderItems.push(action.payload);
      }
    },
    clearRagObjects: (state) => {
      state.ragObjects = [];
    },
  },
  extraReducers: (builder) => {
    getRagObjectsReducerBuilder(builder);
  },
});

export const sidebarReducers = sidebarSlice.reducer;
export const { toggleAccordion, clearRagObjects } = sidebarSlice.actions;
